import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";

const TopbarLayout = ({ children, routes = [] }) => {
  let [sidebarActive, seSidebarActive] = useState(true);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation(); // Hook to get the current route

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };
  const collapseName = `/${location.pathname.split("/").pop()}`;

  return (
    <section className={"overlay"}>
      {/* sidebar */}

      <main>
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <ul
                className="nav bordered-tab d-inline-flex  mb-0"
                id="pills-tab-six"
                role="tablist"
              >
                {routes.map((route, index) => (
                  <li className="nav-item dropdown" key={index}>
                    {route.items && route.items.length > 0 ? (
                      <>
                        {route.icon ? route.icon : <></>}
                        <button
                          className={`nav-link dropdown-toggle px-16 py-10 ${
                            collapseName === route.route ? "active" : ""
                          }`}
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {route.title}
                        </button>
                        <ul className="dropdown-menu">
                          {route.items.map((subRoute, subIndex) => (
                            <li key={subIndex}>
                              <Link
                                className={`dropdown-item ${
                                  collapseName === subRoute.route
                                    ? "active"
                                    : ""
                                }`}
                                to={`.${subRoute.route}`}
                              >
                                {subRoute.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : (
                      <Link
                        to={`.${route.route}`}
                        className={`nav-link px-16 py-10 ${
                          collapseName === route.route ? "active" : ""
                        }`}
                      >
                        <div className="d-flex justify-content-center align-items-center gap-1">
                          <span>{route.icon ? route.icon : <></>}</span>
                          <span>{route.title}</span>
                        </div>
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-auto"></div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className="dashboard-main-body">{children}</div>

        {/* Footer section */}
        {/* <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <p className="mb-0">© 2024 WowDash. All Rights Reserved.</p>
            </div>
            <div className="col-auto">
              <p className="mb-0">
                Made by <span className="text-primary-600">wowtheme7</span>
              </p>
            </div>
          </div>
        </footer> */}
      </main>
    </section>
  );
};

export default TopbarLayout;
